import { Maybe } from 'maybe-not';
import MessageBus from '../utility/message-bus';

export default function openModule(messageBus: MessageBus, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('openModule')) {
        return;
    }

    return function(route: string, data?: string): Promise<void> {
        return messageBus
            .sendRequest<{ status: boolean }>(
                `executeDynamicPlatformAPI`,
                Maybe.just({ functionName: 'openModule', args: [route, data] }).map(JSON.stringify)
            )
            .then(response => {
                if (response.value.status) {
                    return;
                }

                throw new Error('openModule failed');
            });
    };
}
